<template>
    <div>
        <splitpanes :horizontal="is_col_12" class="maps-operations" :dbl-click-splitter="false"
                    @resize="paneSize = $event[1].size">
            <pane :size="100 - paneSize">
                <div>
                    <div class="row justify-content-center map-types-controls" :style="{ 'top': top_px + 'px' }">
                            <AppGoogleMapsTypeControl :show_first_row="false" ref="googleMapsTypeControl"
                                                          @handleMapControlClick="handleMapControlClick"/>
                    </div>
                    <div v-if="selectedOperation" :style="{'top': (top_px + 60) + 'px'}"
                         style="position: absolute; z-index: 1; left: 20px">
                        <AppOperationsWorkOptions :rate_steps="rateSteps" :map-type="selectedMapType" @edit="editScale"
                                                     @changeVisibility="changeVisibility"
                                                     @changeColorPalette="changeColorPalette" ref="operationsWorkOptions"/>
                    </div>
                    <div v-if="!loadingData && !hasOperations" class="no-operation-warning px-2 kt-font-lg">
                        {{ $t('AppOperationsAnalyze.Não há trabalhos para este talhão') }}
                    </div>
                    <div v-if="selectedField" class="field-name" :style="{right: isScreenMobile ? '3%' : (selectedOperation ? paneSize + 1 : 1) + '%'}">
                        {{ selectedField.name }}
                    </div>
                </div>
                <AppGoogleMapsOperations ref="googleMapsOperations" :loading="loadingData"
                                            :google_maps_operations_id="'analyze-operation-maps'" :focused="false"
                                            :position_center="operationMapCenter" :selected_field="selectedField"
                                            :tiles-data="tilesData" :selectedOperation="selectedOperation"/>
            </pane>
            <pane v-if="selectedOperation" style="z-index: 1; background-color: white" min-size="18"
                  max-size="45" :size="paneSize" class="stats">
                <AppOperationsStatsSkeleton v-if="loadingStatistics" :stats="statistics" :operators="operators"
                                               :varieties="varieties" :operation="selectedOperation"
                                            :vehicles="vehicles" :products="products" :pane_size="paneSize"/>

                <AppOperationsStats v-else :stats="statistics" :operators="operators" :varieties="varieties"
                                      :operation="selectedOperation" :vehicles="vehicles" :products="products"
                                      :pane_size="paneSize"/>
            </pane>
        </splitpanes>

        <AppOperationsRateStepsEditDialog :show_edit_dialog="showEditDialog" :rate_steps="rateStepsEdit"
                                          :original-rate-steps="originalRateSteps" :min_value="minValue"
                                          :opacity="opacity" @applyNewScale="applyNewScale"
                                          @hideDialog="closeDialog"/>

        <AppOperationsReportDialog :show-dialog="showReportDialog" :operation="selectedOperation"
                                   :selected-map-type="selectedMapType" :operation-map-center="operationMapCenter"
                                   :selected-field="selectedField" :tiles-data="tilesData"
                                   @hideDialog="closeDialog" @generateReport="generateReport"/>

        <AppOperationsReport v-if="selectedOperation" ref="operationsReport" :operation="selectedOperation"
                             :rate_steps="rateSteps" :map_type="selectedMapType" :stats="statistics"
                             :operators="operators" :varieties="varieties" :vehicles="vehicles" :products="products"/>

        <Dialog :visible.sync="showNoStatsDialog" :style="{width: '500px'}" :header="$t('AppOperationsAnalyze.Atenção')"
                modal>
            <div>
                {{ $t('AppOperationsAnalyze.Não é possível exportar os dados desta operação') }}
            </div>
        </Dialog>

    </div>
</template>

<script>

import 'splitpanes/dist/splitpanes.css'
import {Pane, Splitpanes} from 'splitpanes'
import Dialog from 'primevue/dialog'

import dateFormat from "@/mixins/DateMixin";
import buildColorRange from "@/mixins/ColorMixin";
import hexToRgb from "@/mixins/ColorMixin";
import getUserColorsSet from "@/mixins/ColorMixin";
import buildColorBounds from "@/mixins/ColorMixin";
import formatPercent from "@/mixins/ValuesFormat";
import buildStatistics from "@/utils/OperationsStatisticsBuilder";
import {MAPS_OVERLAY_OPEN_WEATHER_TYPES, MAPS_OVERLAY_WEATHER_TYPES} from "../../real-time/AppOptions";
import AppOperationsStats from "../operation-statistics/AppOperationsStats.vue";
import AppGoogleMapsTypeControl from "@/components/common/AppGoogleMapsTypeControl";
import AppGoogleMapsOperations from "./AppGoogleMapsOperations";
import AppOperationsWorkOptions from "../operation-scale/AppOperationsWorkOptions.vue";
import AppOperationsRateStepsEditDialog from "../operation-scale/AppOperationsRateStepsEditDialog.vue";
import AppOperationsReportDialog from "../operation-report/AppOperationsReportDialog.vue";
import AppOperationsReport from "../operation-report/AppOperationsReport.vue"
import AppOperationsStatsSkeleton from "../operation-statistics/AppOperationsStatsSkeleton.vue";
import {MAP_TYPES} from "../AppAgricultureOptions";

import OperationsService from "@/services/OperationsService";

export default {
    mixins: [buildColorRange, hexToRgb, formatPercent, buildStatistics, getUserColorsSet, buildColorBounds, dateFormat],
    mounted() {
        this.operationsService = new OperationsService();
        this.top_px = this.isScreenMobile ? 50 : 30;
        this.is_col_12 = this.isScreenMobile;
        this.operationMapCenter = this.fieldCenter;
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    data() {
        return {
            operationsService: null,
            top_px: 30,
            is_col_12: false,
            tilesData: {
                requestId: null,
                zooms: [],
                grouped: false,
                color_bounds: [],
                center_tile: false,
                center: {},
                bounds: []
            },
            operationMapCenter: {},
            operationMapBounds: [],
            tilesZooms: [],
            statistics: {},
            operators: [],
            vehicles: [],
            varieties: [],
            products: [],
            rateSteps: [],
            originalRateSteps: [],
            minValue: 0,
            rateStepsEdit: [],
            loadingTiles: false,
            loadingStatistics: false,
            requestId: null,
            layerColorBounds: [],
            opacity: 75,
            paneSize: 18,
            showEditDialog: false,
            showReportDialog: false,
            centerMap: true,
            previousMapEmpty: true,
            showNoStatsDialog: false,
            interval: null
        }
    },
    methods: {
        handleMapControlClick(val) {
            switch (val) {
                case 'roadmap':
                    this.$refs.googleMapsOperations.setUpMapType('roadmap');
                    break;
                case 'hybrid':
                    this.$refs.googleMapsOperations.setUpMapType('hybrid');
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.PRECIPITATION:
                    this.$refs.googleMapsOperations.setupWeatherOverlay(MAPS_OVERLAY_OPEN_WEATHER_TYPES.PRECIPITATION);
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.TEMPERATURE:
                    this.$refs.googleMapsOperations.setupWeatherOverlay(MAPS_OVERLAY_OPEN_WEATHER_TYPES.TEMPERATURE);
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.CLOUDS:
                    this.$refs.googleMapsOperations.setupWeatherOverlay(MAPS_OVERLAY_OPEN_WEATHER_TYPES.CLOUDS);
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.REMOVE:
                    this.$refs.googleMapsOperations.setupWeatherOverlay(MAPS_OVERLAY_WEATHER_TYPES.REMOVE);
                    break;
                default:
            }
        },
        getStatistics() {
            this.clearStatistics();
            this.loadingTiles = true;
            switch (this.selectedOperation.operation_type) {
                case 'SEEDING':
                    this.getOperationStatistics('seedingStatistics')
                    break
                case 'HARVEST':
                    this.getOperationStatistics('harvestStatistics')
                    break
                case 'MOWING':
                    this.getOperationStatistics('mowingStatistics')
                    break
                case 'TILLAGE':
                    this.getOperationStatistics('tillageStatistics')
                    break
                case 'DRY_APPLICATION':
                    this.getOperationStatistics('dryApplicationStatistics')
                    break
                case 'LIQUID_APPLICATION':
                    this.getOperationStatistics('liquidApplicationStatistics')
                    break
                case 'TRANSPORT':
                    this.getOperationStatistics('transportStatistics')
                    break
            }
        },
        getOperationStatistics(endpoint) {
            this.loadingStatistics = true
            this.operationsService.getOperationStatistics(this.selectedOperation.id, endpoint)
                .then(response => {
                    this.parseStatistics(this.buildStatistics(response, this.selectedOperation.operation_type))
                    this.$emit('setAvailableMapTypes', this.parseTitles(response.map_types))
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsAnalyze.Erro'),
                        detail: this.$t('AppOperationsAnalyze.Não foi possível recuperar as estatísticas desta operação'),
                        life: 5000
                    });
                    this.loadingTiles = false;
                }).finally(() => {
                    this.loadingStatistics = false
                })
        },
        parseTitles(mapTypes) {
            if (mapTypes.length === 0) {
                return this.loadStandardMapTypes();
            }

            mapTypes.forEach(mapType => {
                mapType.title = this.$t(`AppAgricultureOptions.${mapType.title}`);
                if (mapType.ddi === '11' || mapType.ddi === '12') {
                    mapType.symbol = this.$t(`AppAgricultureOptions.${mapType.symbol}`);
                }
            })

            return mapTypes.sort((a, b) => a.priority - b.priority);
        },
        loadStandardMapTypes() {
            switch (this.selectedOperation.operation_type) {
                case 'SEEDING':
                    return MAP_TYPES().SEEDING
                case 'HARVEST':
                    return MAP_TYPES().HARVEST
                case 'MOWING':
                    return MAP_TYPES().MOWING
                case 'TILLAGE':
                    return MAP_TYPES().TILLAGE
                case 'DRY_APPLICATION':
                    return MAP_TYPES().DRY_APPLICATION
                case 'LIQUID_APPLICATION':
                    return MAP_TYPES().LIQUID_APPLICATION
                case 'TRANSPORT':
                    return MAP_TYPES().TRANSPORT
            }
        },
        clearData() {
            clearInterval(this.interval);
            this.tilesData = {};
            this.rateSteps = [];
        },
        clearStatistics() {
            this.statistics = {};
            this.operators = [];
            this.vehicles = [];
            this.varieties = [];
            this.products = [];
            this.$emit('clearAvailableMapTypes');
        },
        getFileName() {
            this.clearData();

            let config = {
                work_id: this.selectedOperation.id,
                ddi: this.selectedMapType.ddi
            }

            this.loadingTiles = true;

            this.operationsService.configMbtilesRaster(config)
                .then(response => {
                    this.previousMapEmpty = false;
                    this.tilesZooms = response.zooms;
                    this.operationMapCenter = response.center;
                    this.operationMapBounds = response.bounds;
                    this.requestId = response.request_id;
                    this.getScale(null)
                })
                .catch(error => {
                    this.previousMapEmpty = true;
                    this.loadingTiles = false;
                    if (error.response && error.response.status === 404) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperationsAnalyze.Erro'),
                            detail: this.$t('AppOperationsAnalyze.Não há dados para gerar o mapa desta operação'),
                            life: 5000
                        });
                        return
                    }

                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsAnalyze.Erro'),
                        detail: this.$t('AppOperationsAnalyze.Houve um erro ao recuperar as informações, Tente novamente'),
                        life: 5000
                    });
                })
        },
        getScale(scaleLimits) {
            let params = this.configParams(scaleLimits)
            this.loadingTiles = true;
            this.operationsService.getInitialState(this.requestId, params)
                .then(response => {
                    this.layerColorBounds = response.colors;
                    this.processStepRate(response.colors.length, scaleLimits);
                    this.showEditDialog = false;
                })
                .catch(() => {
                    this.previousMapEmpty = true;
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsAnalyze.Erro'),
                        detail: this.$t('AppOperationsAnalyze.Não foi possível carregar o mapa'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingTiles = false;
                })
        },
        configParams(scaleLimits) {
            if (this.requestId.includes('date')) {
                return {offset: new Date().getTimezoneOffset() / -60};
            }

            if (!scaleLimits) {
                return null
            }

            return {
                num_quantile: scaleLimits.length - 1,
                bounds: JSON.stringify(scaleLimits)
            }
        },
        processStepRate(steps, scaleLimits) {
            let rateStepsTemp = [];
            this.layerColorBounds = this.sortLayerColorBounds()
            let COLORS = scaleLimits ? this.getUserColorsSet(this.rateStepsEdit) : this.setColorRange(steps)
            for (const index in this.layerColorBounds) {
                rateStepsTemp.push({
                    value: this.parseValue(index),
                    color: COLORS[index],
                    percentage: this.formatPercent(this.layerColorBounds[index].area.percent),
                    visible: true,
                    invalid: false
                })
            }
            if (!this.selectedMapType.grouped) {
                this.minValue = this.layerColorBounds[this.layerColorBounds.length - 1].bound.lower
            }
            this.rateSteps = rateStepsTemp;
            if (scaleLimits === null) {
                this.originalRateSteps = JSON.parse(JSON.stringify(rateStepsTemp));
            }
            this.tilesData = {
                requestId: this.requestId,
                zooms: this.tilesZooms,
                grouped: this.selectedMapType.grouped,
                color_bounds: this.buildColorBounds(this.layerColorBounds, COLORS, this.opacity),
                center_tile: this.centerMap,
                center: this.operationMapCenter,
                bounds: this.operationMapBounds
            }
        },
        sortLayerColorBounds() {
            if (this.selectedMapType.grouped && this.selectedMapType.ddi !== 'date') {
                return this.layerColorBounds.sort((a, b) => a.bound.upper.localeCompare(b.bound.upper))
            }

            return this.layerColorBounds.sort((a, b) => b.bound.upper - a.bound.upper || b.bound.lower - a.bound.lower)
        },
        setColorRange(steps) {
            if (this.selectedMapType.grouped) {
                return this.buildColorRange(steps, 0, 290)
            }
            return this.buildColorRange(steps)
        },
        parseValue(index) {
            if (this.selectedMapType.value === 'date') {
                return this.dateFormat(Number.parseInt(this.layerColorBounds[index].bound.upper), 'GMT')
            }

            if (this.selectedMapType.value === 'vehicle') {
                let foundVehicle = this.vehicles.find(vehicle => vehicle.id === this.layerColorBounds[index].bound.upper)
                if (foundVehicle) {
                    return foundVehicle.display_name
                }

                return '---'
            }

            return this.layerColorBounds[index].bound.upper
        },
        parseStatistics(builtStatistics) {
            this.statistics = builtStatistics.statistics
            this.operators = builtStatistics.operators
            this.vehicles = builtStatistics.vehicles
            this.varieties = builtStatistics.varieties
            this.products = builtStatistics.products
        },
        changeVisibility(scaleSteps) {
            let tmpTilesData = JSON.parse(JSON.stringify(this.tilesData))
            let tmpColors = tmpTilesData.color_bounds

            tmpColors.forEach(bound => {
                let boundFound = scaleSteps.find(step => step.value === this.getBoundFromValue(bound.upper))

                if (boundFound) {
                    bound.color = this.hexToRgb(boundFound.color, boundFound.visible ? this.opacity : 0)
                }
            })

            tmpTilesData.center_tile = false
            this.tilesData = tmpTilesData
        },
        changeColorPalette(scaleSteps) {
            this.rateStepsEdit = JSON.parse(JSON.stringify(scaleSteps))

            let newScale = []
            this.rateStepsEdit.forEach(step => {
                newScale.push(step.value)
            })
            newScale.push(this.minValue)

            this.getScale(newScale)
        },
        getBoundFromValue(upperBound) {
            if (this.selectedMapType.ddi === 'operator' || !this.selectedMapType.grouped) {
                return upperBound
            }

            if (this.selectedMapType.grouped) {
                if (this.selectedMapType.ddi === 'date') {
                    return this.dateFormat(Number.parseInt(upperBound), 'GMT');
                }

                if (this.selectedMapType.ddi === 'vehicle') {
                    let foundVehicle = this.vehicles.find(vehicle => vehicle.id === upperBound)
                    return foundVehicle ? foundVehicle.display_name : '---'
                }
            }
        },
        editScale() {
            this.rateStepsEdit = JSON.parse(JSON.stringify(this.rateSteps))
            this.showEditDialog = true
        },
        applyNewScale(rateSteps, opacity) {
            this.$refs.operationsWorkOptions.changeGradient('custom')
            this.rateStepsEdit = JSON.parse(JSON.stringify(rateSteps))

            let newScale = []
            this.rateStepsEdit.forEach(step => {
                newScale.push(step.value)
            })
            newScale.push(this.minValue)

            this.opacity = opacity
            this.getScale(newScale)
        },
        closeDialog() {
            this.showEditDialog = false
            this.showReportDialog = false
        },
        openReportDialog() {
            if (Object.keys(this.statistics).length === 0) {
                this.showNoStatsDialog = true
                return;
            }

            this.showReportDialog = true
        },
        generateReport() {
            this.$refs.operationsReport.generateReport();
            this.closeDialog();
        },
        initGetOperationMap() {
            this.centerMap = this.previousMapEmpty
            this.getFileName()
        },
        sendKeepAlive() {
            this.operationsService.sendKeepAlive({request_id: this.requestId});
        }
    },
    watch: {
        selectedOperation: function () {
            if (!this.selectedOperation) {
                return;
            }
            this.previousMapEmpty = true;
            this.clearData();
            this.getStatistics();
        },
        selectedMapType: function () {
            if (!this.selectedMapType) {
                return;
            }
            this.initGetOperationMap()
        },
        requestId: function () {
            if (!this.requestId) {
                return;
            }

            this.interval = setInterval(this.sendKeepAlive, 60 * 1000);
        },
        selectedField: function () {
            this.clearData();
        }
    },
    computed: {
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        },
        loadingData: function () {
            return this.loadingTiles || this.loading;
        }
    },
    props: {
        selectedOperation: {
            type: Object
        },
        selectedMapType: {
            type: Object
        },
        fieldCenter: {
            type: Object
        },
        selectedField: {
            type: Object
        },
        hasOperations: {
            type: Boolean
        },
        loading: {
            type: Boolean
        }
    },
    components: {
        AppOperationsReportDialog,
        Pane,
        Splitpanes,
        Dialog,
        AppOperationsStats,
        AppGoogleMapsOperations,
        AppGoogleMapsTypeControl,
        AppOperationsWorkOptions,
        AppOperationsRateStepsEditDialog,
        AppOperationsReport,
        AppOperationsStatsSkeleton
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/constants";

.splitpanes__pane.stats {
    padding: 10px;
    border-radius: 5px;
    overflow-y: auto;
}

.splitpanes__pane.stats::-webkit-scrollbar {
    width: 10px;
}

.splitpanes__pane.stats::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(98, 95, 95, 0.8);
}

.splitpanes__pane.stats::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 2px rgba(98, 95, 95, 0.7);
}

.splitpanes__pane.stats::-webkit-scrollbar-thumb:hover {
    -webkit-box-shadow: inset 0 0 5px rgba(98, 95, 95, 0.7);
}

.p-slider.p-slider-horizontal {
    height: 0.5rem;
    cursor: pointer;
}

.no-operation-warning {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 1rem;
    margin-inline: auto;
    width: fit-content;
    background: rgba(254, 254, 254, 0.70);
    border-radius: 0.5rem;
}

.field-name {
    color: white;
    position: absolute;
    z-index: 1;
    top: 1rem;
    user-select: none;
}

.map-types-controls {
    position: absolute;
    z-index: 2;
    left: 30px;
}

</style>
